import React, { KeyboardEvent } from 'react'

import * as Styled from './styles'

export type SelectContainerProps = {
  children: React.ReactNode
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void
}

export const SelectContainer = React.forwardRef<HTMLDivElement, SelectContainerProps>(
  ({ children, onKeyDown }, ref) => {
    return (
      <Styled.SelectContainer ref={ref} onKeyDown={onKeyDown}>
        {children}
      </Styled.SelectContainer>
    )
  },
)
